import { createSvgComponent } from "../../icon/createSvgComponent";
import PointCoupon from "@core/icon/assets/point-coupon.svg";
export default createSvgComponent(PointCoupon);